// import { logger } from '@/helpers';
import { defineComponent, } from 'vue'

// import { useStore } from "vuex";

export default defineComponent({
  // type inference enabled
  
  
  // setup() {
  //   const store = useStore();

  //   console.log(store.state.logs)
    

  

  //   // const year = ref< number>(2022)

  //   // year.value = 123
    
  //   onMounted(() => {
    
      
    
  //   })
  // },
})
